import {createContext} from "react"

const FloatingContext=createContext({})

export default FloatingContext